import React, {memo} from "react";
import {Modal, ModalHeader, ModalBody} from "reactstrap";
import PropTypes from "prop-types";
import AddUserForm from "../Forms/AddUserForm";
import Loader from "../Loader";

const AddUser = (props) => {
  const {open, onClose, formType = "Add"} = props;

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
        <Loader />
        <ModalHeader>
          {formType === "Add"
            ? "Add User"
            : formType === "Edit"
              ? "Edit User"
              : "Change Password"}
        </ModalHeader>
        <ModalBody>
          <div className="pl-lg-4">
            <AddUserForm onClose={onClose} formType={formType} />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

AddUser.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  formType: PropTypes.string,
};
export default memo(AddUser, areEqual);
